export const USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE =
  "USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE";
export const USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS =
  "USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS";
export const USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT =
  "USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT";
export const CLEAR_USER_LIST_STATE = "CLEAR_USER_LIST_STATE";
export const UPDATE_USER_LIST_STATE = "UPDATE_USER_LIST_STATE";
export const UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE =
  "UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE";
